import React from "react";
import { Form } from "react-bootstrap";

class SelectField extends React.Component {
  onBlurChange = (e, fieldName, callback) => {
    let isValid = true;

    if (isValid) {
      callback(e, fieldName);
    }
  };

  renderComponent = () => {
    const {
      name,
      action,
      onBlurAction,
      options,
      value,
      required,
      id,
      disabled = false,
      className,
      style,
    } = this.props;
    return (
      <div>
        {name !== "expiryMonth" && name !== "expiryYear" ? (
          <div>
            <Form.Select
              name={name}
              value={value}
              required={required}
              disabled={disabled}
              className={className}
              id={id}
              style={style}
              onChange={(e) => action(e, name)}
            >
              <option value={""}>Select {name}...</option>
              {options.map((val, index) => {
                return (
                  <option value={val.id} key={index}>
                    {val.name}
                  </option>
                );
              })}
            </Form.Select>
          </div>
        ) : (
          <div>
            <Form.Select
              name={name}
              value={value}
              required={required}
              className={className}
              disabled={disabled}
              onChange={(e) => action(e, name)}
              onBlur={(e) => this.onBlurChange(e, name, onBlurAction)}
            >
              <option value={""}>Select {name}...</option>
              {options.map((val, index) => {
                return (
                  <option value={val.id} key={index}>
                    {val.name}
                  </option>
                );
              })}
            </Form.Select>
          </div>
        )}
      </div>
    );
  };

  render() {
    return this.renderComponent();
  }
}
export default SelectField;
